import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // Use Link from react-router-dom for navigation
import "./MegaMenu.css";
import TopHeader from "../TopHeader";
const MegaMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [clickCount, setClickCount] = useState(0); // To count clicks for mega menu collapse

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleMouseEnter = (menu) => {
    setActiveMenu(menu);
  };

  const handleMouseLeave = () => {
    setActiveMenu(null);
  };

  const handleClickOutside = (e) => {
    // Close the mobile menu if clicked outside of it
    if (!e.target.closest(".mega-menu") && !e.target.closest(".nav-menu")) {
      setActiveMenu(null);
    }

    // Close the mobile menu if clicked outside of it
    if (!e.target.closest(".header-main") && menuOpen) {
      setMenuOpen(false);
    }
  };

  const handleMegaMenuClick = (menuKey) => {
    if (activeMenu === menuKey) {
      setClickCount(prevCount => prevCount + 1);
    } else {
      setClickCount(1);
      setActiveMenu(menuKey);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Reset click count when the menu is closed
  useEffect(() => {
    if (clickCount >= 2) {
      setActiveMenu(null); // Collapse mega menu after 2 clicks
      setClickCount(0);
    }
  }, [clickCount]);

  const megaMenuContent = {
    Printing: [
      { section: "Section 1", links: [{ name: "Custom flyers Printing Services", path: "/custom-flyers-printing-services" }, { name: "Certificate Printing Services", path: "/certificate-printing-services" }, { name: "Business Card Printing", path: "/business-card-printing" }, { name: "School Copy Printing", path: "/school-copy-printing" }, { name: "Presentation Printing", path: "/presentation-printing" }, { name: "Printing of Bags", path: "/printing-of-bags" }] },
      { section: "Section 2", links: [{ name: "Indoor Banners", path: "/indoor-banners" }, { name: "Stationary Banners", path: "/printing-of-stationary-banners" }, { name: "Printing of Flags", path: "/printing-of-flags" }, { name: "Table Signs", path: "/printing-table-signs" }, { name: "Backlit Posters", path: "/printing-backlit-posters" }, { name: "Announcements", path: "/printing-of-announcements" }] },
      { section: "Section 3", links: [{ name: "Printing Blueprints", path: "/printing-blueprints" }, { name: "Car Magnets", path: "/car-magnets" }, { name: "Printing of Fabric Backdrops", path: "/printing-of-fabric-backdrops" }, { name: "Printing of Menus", path: "/architecture-construction-and-engineering-prints" }, { name: "Ace Prints", path: "/printing-backlit-posters" } ] },
      { section: "image2", image: "/printingservices.jpg" }, // Only image in last section
    ],
    Office: [
      { section: "Section 1", links: [{ name: "Custom Envelops", path: "/custom-envelops" }, { name: "Custom Notepads", path: "/custom-notepads" }, { name: "Stamps and Embossers", path: "/stamps-and-embossers" }, { name: "Document Printing & Binding", path: "/document-printing-and-binding" }, { name: "Rack Card Design", path: "/rack-card-design" }, { name: "Printing of Hangtags", path: "/printing-of-hangtags" } ] },
      { section: "Section 2", links: [{ name: "Window Graphics", path: "/window-graphics" }, { name: "Banners Signs & Posters", path: "/banners-signs-and-posters" }, { name: "Printing of Post It Notes", path: "/printing-of-post-it-notes" }, { name: "Printing of Fabric Table Throws", path: "/printing-of-fabric-table-throws" }, { name: "Fabric Banners", path: "/printing-of-fabric-banners" }] },
      { section: "Section 3", links: [{ name: "Outdoor Banners", path: "/outdoor-banners" }, { name: "Table Top Banners", path: "/printing-table-top-banners" }, { name: "Seg Graphics", path: "/seg-graphics-printing" }, { name: "Signboards Printing", path: "/printing-signboards" }, { name: "Poster Prints", path: "/poster-prints" }] },
      { section: "Section 4", image: "/officeprint.jpg" }, // Only image in last section
    ],
    Custom: [
      { section: "Printing Services", links: [{ name: "Door Hanger Printing", path: "/door-hanger-printing" }, { name: "Custom Note Cards", path: "/custom-note-cards" }, { name: "Custom Pocket Folder", path: "/custom-pocket-folder" }, { name: "Postcard Printing & Designing", path: "/postcard-printing-and-designing" }, { name: "Stickers and Labels", path: "/printing-of-stickers-and-labels" } ] },
      { section: "Section 2", links: [{ name: "Flutter Flags", path: "/printing-of-flutter-flags" }, { name: "Large Tripod Banners", path: "/large-tripod-banners" }, { name: "Retractable Banners", path: "/printing-of-retractable-banners" }, { name: "Corrugated Plastic Sign", path: "/printing-corrugated-plastic-signs" }] },
      { section: "Section 3", links: [{ name: "Table Tent Card Printing", path: "/table-tent-card-printing" }, { name: "Floor Graphics", path: "/floor-graphics" }, { name: "Wall Graphics", path: "/wall-graphics" }, { name: "Printing of Boxes", path: "/printing-of-boxes" }] },
      { section: "image1", image: "/customitems.jpg" }, // Only image in last section
    ],
    Specialty: [
      { section: "Section 1", links: [{ name: "Styrene Signs", path: "/sytrene-sign-printing" }, { name: "Photo Posters", path: "/photo-posters-printing" }, { name: "Greeting Cards", path: "/printing-greeting-cards" }, { name: "Invitations", path: "invitations" }, { name: "NoteCards", path: "/printing-of-notecards" }] },
      { section: "Section 2", links: [{ name: "Automotive", path: "/automotive-printing" }, { name: "Education", path: "/printing-for-education" }, { name: "Events & Festivals", path: "/events-and-festivals" }, { name: "Thankyou Cards", path: "/printing-thankyou-cards" }, { name: "Postcards", path: "/printing-of-postcards" }] },
      { section: "Section 3", links: [{ name: "RealEstate", path: "/realestate-printing" }, { name: "Restaurant", path: "/restaurants-printing" }, { name: "Retail", path: "/retail-printing" },  { name: "Travel", path: "/travel-printing" }] },
      { section: "Section image1", image: "/specialityprintings.jpg" }, // Only image in last section
    ]
  };

  return (

    <div>
      <TopHeader />
    <header className="header-main">
      <div className="header-inner">
        {/* Logo */}
        <div className="logo">
          <a href="/">
            <img src="/resizedlogo.png" alt="Logo" />
          </a>
        </div>

        {/* Hamburger for Mobile View */}
        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? (
            <svg
              className="closeBurger"
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <g fill="none" stroke="#000" strokeLinecap="round" strokeWidth="1.5">
                <path strokeLinejoin="round" d="m15 18.5l5-5m0 5l-5-5" />
                <path d="M21 6H3m18 4H3m8 4H3m8 4H3" opacity="1" />
              </g>
            </svg>
          ) : (
            <svg
              className="openBurger"
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="#000"
                d="M21 15.61L19.59 17l-5.01-5l5.01-5L21 8.39L17.44 12zM3 6h13v2H3zm0 7v-2h10v2zm0 5v-2h13v2z"
              />
            </svg>
          )}
        </div>

        {/* Navigation List */}
        <nav className={`nav-menu ${menuOpen ? "menu-open" : "menu-closed"}`}>
          <ul>
            {[
              { label: "Printing Services", key: "Printing" },
              { label: "Office Supplies", key: "Office" },
              { label: "Custom Items", key: "Custom" },
              { label: "Specialty Products", key: "Specialty" },
            ].map((menu, index) => (
              <li
                key={index}
                className="nav-item"
                onMouseEnter={() => handleMouseEnter(menu.key)}
                onMouseLeave={handleMouseLeave}
                onClick={() => handleMegaMenuClick(menu.key)} // Handle click
              >
                <span className="headerlinks">
                  {menu.label} <i className="fa fa-caret-down"></i>
                </span>
                {activeMenu === menu.key && (
                  <div className="mega-out">
                    <div className="mega-menu">
                      {megaMenuContent[menu.key].map((section, sectionIndex) => (
                        <div className="mega-menu-section" key={sectionIndex}>
                          {/* Only render links if present */}
                          {section.links ? (
                            <ul>
                              {section.links.map((link, linkIndex) => (
                                <li key={linkIndex}>
                                  <Link to={link.path}>{link.name}</Link>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            // Only render the image for the last section
                            section.image && (
                              <div className="mega-menu-image">
                                <img src={section.image} alt={section.section} />
                              </div>
                            )
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </li>
            ))}
            {/* Separate Links for Blog, Careers, and Support */}
            <li className="nav-item">
              <a href="/about" className="headerlinks">About</a>
            </li>
            <li className="nav-item">
              <a href="/blogs/" className="headerlinks">Blogs</a>
            </li>
            <li className="nav-item">
              <a href="/contact" className="headerlinks">Contact</a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
    </div>
  );
};

export default MegaMenu;
